import { Navigate, useLocation } from "react-router-dom";
import { Show } from "@clerk/react";

function ToSignIn() {
  const loc = useLocation();
  sessionStorage.setItem("tp_redirect", loc.pathname + loc.search);
  return <Navigate to="/sign-in" replace />;
}

export default function RequireAuth({ children }) {
  return (
    <>
      <Show when="signed-in">{children}</Show>
      <Show when="signed-out"><ToSignIn /></Show>
    </>
  );
}
